import { createRoot } from 'react-dom/client';
import './assets/styles/index.scss';
import AppProvider from './providers/AppProvider';
import { AppRoutes } from './routers';

const App = () => (
  <AppProvider>
    <AppRoutes />
  </AppProvider>
);

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);
